import { Store } from '@webtides/element-js';

class WindowStore extends Store {
    constructor() {
        super();
        window.onresize = () => {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        };
    }

    properties() {
        return {
            width: undefined,
            height: undefined,
        };
    }
}

export const windowStore = new WindowStore();
